import { uploadPublicImage } from "@/god";

/**
 * Validate a category form before create/update.
 *
 * @param {{ name: string, packages: Array<{ id: string }> }} form
 * @return {?string} a user-facing error message, or null when valid.
 */
export function validateCategoryForm(form) {
  const { name, packages } = form;

  if (!name || !name.trim()) {
    return "กรุณากรอกชื่อหมวดหมู่";
  }

  if (!packages.length) {
    return "กรุณาเลือก Package อย่างน้อย 1 รายการ";
  }

  return null;
}

/**
 * Build the request payload for creating/updating a Ruejai Club category.
 *
 * @param {{ name: string, iconFile: ?File, packages: Array<{ id: string }> }} form
 * @param {?string} fallbackIconUrl - used when no new icon file is picked
 *   (create: null; update: the already-saved icon url).
 *
 * @return {Promise<{ name: string, icon_url: ?string, package_ids: string[] }>}
 */
export async function buildCategoryParams(form, fallbackIconUrl = null) {
  const { name, iconFile, packages } = form;

  const iconUrl = iconFile
    ? await uploadPublicImage(iconFile, name, "article")
    : fallbackIconUrl;

  return {
    name,
    icon_url: iconUrl,
    package_ids: packages.map(({ id }) => id),
  };
}
